// extracted by mini-css-extract-plugin
export default {"appLoaderOverlay":"loader_appLoaderOverlay__6Sm6f"};